module.exports = __webpack_public_path__ + "static/media/cheese.b3b708fe.png";